import { render, staticRenderFns } from "./EmployeeSalaryStatementStatusCard.vue?vue&type=template&id=0b75683b"
import script from "./EmployeeSalaryStatementStatusCard.vue?vue&type=script&lang=js"
export * from "./EmployeeSalaryStatementStatusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports